import { SCATTERPLOT_CHART, BAR_CHART, HISTOGRAM_CHART, LINE_CHART, PARALLEL_COORDINATES_CHART } from "../Canvas/Constants";
import { BrushingDataSet, brushingDataset} from "../../Globals/Globals";
import * as aggregation from "../aggregation/countAggregation";
import {SbarChartResizeYAxis, 
        SbarChartElements,
        SscatterPlotElements,
        ShistogramElements,
        SremoveScatterPlotBrushElements,SbarChartElementsCount,SbarChartElementsAvg, SLineChartResizeYAxis
        } from './ScatterPlotBrushElements'
import { PREDICTION_COLOR, REALDATA_COLOR, BRUSHING_COLOR, NO_PREDICTION_COLOR } from '../../Globals/ColorConstants'
import * as d3 from "d3";
import {removeBrushElements, lineChartBrushElements, scatterPlotElements, histogramBrushElements, findMaxForBarChart, parallelCoordinatesBrushElements} from '../Brushing/BrushingElements'
export function scatterPlotBrush(ggraphbrushEnable, currentID, brushingPointsScatterPlotArray, brushingDataset: BrushingDataSet){

    if(ggraphbrushEnable == 0 || ggraphbrushEnable == 1)
    {
        
                var datasetIds = []
                var xaxis =  brushingDataset.getBrushingScatterPlotAxis().xaxis
                var yaxis =  brushingDataset.getBrushingScatterPlotAxis().yaxis

                brushingPointsScatterPlotArray.forEach(brushingPointsScatterPlot => {
                                        
                        datasetIds.push(brushingPointsScatterPlot.dataID)                
                })
                removeBrushElements(currentID)
                brushingDataset.getActualMap().forEach(function(datasetValue, datasetKey, map) {
                        
                        if(datasetKey != currentID)
                        {

                                if (datasetValue.type == BAR_CHART)
                                {       
                                        
                                        var maxValue = findMaxForBarChart(datasetIds, 
                                                datasetValue.linearXScale, 
                                                datasetValue.linearYScale, 
                                                datasetValue.xaxis, 
                                                datasetValue.yaxis,
                                                datasetValue, datasetKey)
                                            console.log('maxValuebrushingPointsHistogramArray',maxValue)   
                                   
                                }
                                else if (datasetValue.type == HISTOGRAM_CHART)
                                {      
                                       
                                        histogramBrushElements(datasetValue.xaxis,datasetKey, datasetIds, datasetValue)      

                                }
                                else if (datasetValue.type == SCATTERPLOT_CHART)
                                {       
                                      
                                        scatterPlotElements([],datasetKey)
                                      
                                        scatterPlotElements(datasetIds,datasetKey)
                                        
                                }  else if (datasetValue.type == LINE_CHART) {

                                        lineChartBrushElements(datasetIds, datasetKey, datasetValue) 
                                }
                                else if (datasetValue.type == PARALLEL_COORDINATES_CHART) {

                                        parallelCoordinatesBrushElements(datasetIds, datasetKey, datasetValue) 
                                }
                                      
                        }
                                
                }) 
    }
    else
    {
        removeBrushElements(currentID)
    }
}